;
define("error_management_expired_link.tpl", function(){});

